
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.216 10.919H2.031A1.981 1.981 0 01.05 8.938V4.063A1.981 1.981 0 012.031 2.08H3.25c.32 0 .598.212.692.518a.758.758 0 01-.269.831.693.693 0 01-.423.13H2.031a.456.456 0 00-.456.456v4.969a.456.456 0 00.456.456H3.25c.174 0 .316.049.423.129a.758.758 0 01.27.831.726.726 0 01-.693.518h-.034zM9.784 10.919h1.185a1.982 1.982 0 001.981-1.981V4.063a1.981 1.981 0 00-1.981-1.982H9.75a.726.726 0 00-.692.518.758.758 0 00.269.831c.107.08.249.13.423.13h1.219a.456.456 0 01.456.456v4.969a.457.457 0 01-.456.456H9.75a.693.693 0 00-.423.129.758.758 0 00-.27.831.726.726 0 00.693.518h.034zM5.96.273a.763.763 0 011.303.54v11.374a.763.763 0 01-1.526 0V.813c0-.203.08-.397.224-.54z","fill":"#fff","stroke":"#fff","stroke-width":".1"}})])
          )
        }
      }
    